export default{
    apiKey: "AIzaSyDHELQXDnU8DRFSYP2Xcibaf639ZUxj7m4",
    authDomain: "timeforacoffee-2019.firebaseapp.com",
    databaseURL: "https://timeforacoffee-2019.firebaseio.com",
    projectId: "timeforacoffee-2019",
    storageBucket: "timeforacoffee-2019.appspot.com",
    messagingSenderId: "376478292639",
    appId: "1:376478292639:web:671249ec07881a7ffa20aa",
    measurementId: "G-LXEXWJZBC9"
}


// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js